import { render } from "./MBPCheckbox.vue?vue&type=template&id=ec530fee&scoped=true"
import script from "./MBPCheckbox.vue?vue&type=script&lang=js"
export * from "./MBPCheckbox.vue?vue&type=script&lang=js"

import "./MBPCheckbox.vue?vue&type=style&index=0&id=ec530fee&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec530fee"]])

export default __exports__